import React, { useEffect, useState } from "react";
import "./profile.css";
import api from "../../axiosInstance";
import profileimag from "../../Assets/profile.jpg"
import emailicon from "../../Assets/ProviderImage/envelope.png";
import telephone from "../../Assets/ProviderImage/telephone.png";
import id from "../../Assets/ProviderImage/id-card.png";

function Profile() {
  const parent_id = sessionStorage.getItem("userid");

  const [originalData, setOriginalData] = useState({});
  const [formData, setFormData] = useState({
    parent_id,
    type: originalData?.type,
    name: "",
    password: "",
    email: "",
    email2: "",
    phone: "",
    phone2: "",
    address: "",
    bank_details: "",
    other_details: "",
  });

  useEffect(() => {
    getUserProfileData();
  }, []);

  const getUserProfileData = async () => {
    try {
      const response = await api.get(`/distributor/${parent_id}`);
      if (response?.status === 200) {
        console.log("Fetched profile data:", response.data?.data);
        setOriginalData(response.data?.data || {}); // Store original data for change detection
        setFormData((prevData) => ({
          ...prevData,
          ...response.data?.data,
        }));
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "radio" ? Number(value) : value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Only send changed fields
    const modifiedData = Object.fromEntries(
      Object.entries(formData).filter(
        ([key, value]) => originalData[key] !== value
      )
    );
    if (Object.keys(modifiedData).length === 0) {
      alert("No changes detected!");
      return;
    }
    const withtypemodifiedData = {
      ...modifiedData,
      type: originalData?.type
    }
    console.log("modified data", withtypemodifiedData);
    try {
      const response = await api.put(`/distributor/${parent_id}`, withtypemodifiedData);
      if (response.status === 200) {
        alert(`Form submitted successfully! ${response?.data?.message}`);
        console.log("Updated Data:", response?.data);
        setOriginalData(formData); // Update original data after successful submission
      }
    } catch (error) {
      alert(`Error: ${error?.response?.data?.error}`);
      console.error("Update Error:", error);
    }
  };
  return (

    <div className="row ">
      <div className="col-md-12 col-12 p-0 align-items-center">
        <h3 className="distributerfont ps-3">Profile</h3>
        <div className="row gradient-bg distributerfont d-flex justify-content-center align-items-center">


          {/* Left Profile Section */}
          <div className="me-4 rounded border shadow bg-white py-5" style={{ width: '400px', height: 'fit-content' }}>
            <div className="text-center mb-4">
              <div className="position-relative">
                <img
                  src={profileimag}
                  alt="Profile"
                  className="rounded-circle border border-4 border-warning"
                  style={{ width: '100px', height: '100px' }}
                />
                {/* <i class="bi bi-camera-fill"></i> */}
                <div className="input-group mb-3" style={{
                  position: 'absolute', top: '50%', left: '57%', bottom: '50%', right: '50%'
                }}>
                  {/* Hidden File Input */}
                  <input
                    type="file"
                    className="form-control"
                    id="inputGroupFile02"
                    style={{ display: 'none' }}
                  />

                  {/* Upload Button */}
                  <button
                    type="button"
                    className="bg-primary text-white rounded-circle p-1 border-0"
                    style={{
                      width: '32px',
                      height: '32px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    onClick={() => document.getElementById('inputGroupFile02').click()}
                  >
                    <i className="bi bi-camera"></i>
                  </button>
                </div>

              </div>
            </div>
            <h5 className="text-center mb-3">{formData.name}</h5>
            <hr>
            </hr>
            <div className="d-flex align-items-center mb-2">
              <img src={emailicon} style={{ width: '25px' }}></img>    &nbsp; &nbsp;
              <span>{formData.email}</span>
            </div>
            <hr></hr>

            <div className="d-flex align-items-center mb-2">

              <img src={telephone} style={{ width: '25px' }}></img>  &nbsp; &nbsp;
              <span style={{fontFamily:'cursive'}}>{formData.phone}</span>
            </div>
            <hr>
            </hr>
            <div className="mt-3 align-items-center justify-content-center">
              <img src={id} style={{ width: '25px' }}></img> &nbsp; &nbsp;
             {formData.address}
            </div>
          </div>

          {/* Right Section */}
          <div className="me-4 rounded border shadow bg-white py-4" style={{ width: '600px', height: 'fit-content' }}>
            <div className="m-3">

              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* Left Side - Input Fields */}
                  <div className="col-md-6">
                    {[
                      { label: "Name", name: "name", type: "text", position: 1 },
                      { label: "Password", name: "password", type: "password", position: 3 },
                      { label: "Email 1", name: "email", type: "email", position: 4 },
                      { label: "Email 2", name: "email2", type: "email", position: 5 },
                      { label: "Phone Number", name: "phone", type: "text", position: 6 },
                      { label: "Phone Number 2", name: "phone2", type: "text", position: 7 },
                    ]
                      .sort((a, b) => a.position - b.position)
                      .map((field) => (
                        <div key={field.name} className="mb-3">
                          <label htmlFor={field.name} className="form-label">
                            {field.label}
                          </label>
                          <input
                            className="form-control"
                            name={field.name}
                            type={field.type}
                            placeholder={field.label}
                            value={formData[field.name]}
                            required={field.required}
                            style={{fontFamily:'cursive'}}
                          />
                        </div>
                      ))}
                  </div>

                  {/* Right Side - Textarea Fields */}
                  <div className="col-md-6">
                    {[
                      { label: "Address", name: "address" },
                      { label: "Bank Details", name: "bank_details" },
                      { label: "Other Details", name: "other_details" },
                    ]
                      .sort((a, b) => a.position - b.position)
                      .map((field) => (
                        <div key={field.name} className="mb-3">
                          <label htmlFor={field.name} className="form-label">
                            {field.label}
                          </label>
                          <textarea
                            className="form-control"
                            placeholder={field.label}
                            name={field.name}
                            value={formData[field.name] || ""}
                            onChange={handleChange}
                          />
                        </div>
                      ))}
                  </div>
                </div>
                <hr></hr>

                <button type='reset' className='btncancel rounded m-1 p-2' >Cancel</button>
                <button type='submit' className='btnsave rounded m-1 p-2'>Submit</button>
              </form>

            </div>

          </div>
        </div>

      </div>
    </div>


  );
}

export default Profile;
